export default {
      id: "circle-done-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "img/icons.svg#circle-done",
      toString: function () {
        return this.url;
      }
    }